const vertexShader = /* glsl */ `
varying vec3 vNormal;
varying vec2 vUv;
varying vec3 vWorldPosition;

varying vec3 vObjectPosition;
varying vec3 vObjectNormal;


/*
 * Per-vertex surface direction generated by
 * computeCurvatureDirections().
 *
 * This remains in object space so it stays
 * attached to the model.
 */
attribute vec3 hatchDirection;
varying vec3 vHatchDirection;


void main() {

    vUv =
        uv;


    vObjectPosition =
        position;


    vObjectNormal =
        normalize(
            normal
        );


    /*
     * Interpolated curvature-derived tangent
     * direction for TAM orientation.
     */
    vHatchDirection =
        normalize(
            hatchDirection
        );


    vNormal =
        normalize(
            mat3(
                modelMatrix
            ) *
            normal
        );


    vec4 worldPosition =
        modelMatrix *
        vec4(
            position,
            1.0
        );


    vWorldPosition =
        worldPosition.xyz;


    gl_Position =
        projectionMatrix *
        viewMatrix *
        worldPosition;
}

`;

export default vertexShader;
